import {Directive, DirectiveBinding} from 'vue';

const TOGGLE_CSS_CLASS = 'show';

interface DropdownHTMLElement extends HTMLElement {
    dropdownTarget: HTMLElement
    dropdownDropdownTargetHandler: (event: Event) => void
    dropdownDropdownHandler: (event: Event) => void
}

interface DropdownValue {
    variable: Record<string, HTMLElement>
    key: string
}

const handleElement = (element: DropdownHTMLElement, target: HTMLElement): void => {

    element.dropdownTarget = target;

    if (element.dropdownTarget) {

        element.dropdownDropdownTargetHandler = function (event): void {

            element.dropdownTarget.classList.remove(TOGGLE_CSS_CLASS);

            window.removeEventListener('click', element.dropdownDropdownTargetHandler);
        };

        element.dropdownDropdownHandler = function (event) {

            event.preventDefault();

            if (element.dropdownTarget.classList.contains(TOGGLE_CSS_CLASS)) {

                element.dropdownTarget.classList.remove(TOGGLE_CSS_CLASS);
            } else {

                element.dropdownTarget.classList.add(TOGGLE_CSS_CLASS);

                setTimeout(
                    () => window.addEventListener('click', element.dropdownDropdownTargetHandler, true),
                    100
                );
            }
        };

        element.addEventListener('click', element.dropdownDropdownHandler);
    }
}

const directive: Directive<DropdownHTMLElement> = {
    mounted(element: DropdownHTMLElement, binding: DirectiveBinding<DropdownValue | undefined>): void {

        if (binding.value) {

            handleElement(element, binding.value.variable[binding.value.key]);
        } else {

            Object
                .keys(binding.modifiers)
                .filter((reference: string) => !!binding.instance?.$refs[reference])
                .forEach((reference: string) => handleElement(element, binding.instance?.$refs[reference]))
        }
    },
    unmounted(element: DropdownHTMLElement): void {

        element.removeEventListener('click', element.dropdownDropdownHandler);
        window.removeEventListener('click', element.dropdownDropdownTargetHandler);
    }
}

export default directive;